import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


import { StompService } from 'ng2-stomp-service';


import {AppComponent} from './app.component';


import {routes} from "./app.router";
import {HttpClientModule} from "@angular/common/http";
import { DrinkAutomaticMachineComponent } from './drink-automatic-machine/drink-automatic-machine.component';
import { FillMachineComponent } from './fill-machine/fill-machine.component';
import {DrinkMachineStorageService} from "./Services/DrinkMachineService/drink-machine-config-service";



@NgModule({
  declarations: [
    AppComponent,
    DrinkAutomaticMachineComponent,
    FillMachineComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    // FormsModule,
    HttpClientModule,
    // CountryPickerModule.forRoot(),
     routes],


  providers: [DrinkMachineStorageService],
  bootstrap: [AppComponent]
})
export class AppModule {
}





// WEBPACK FOOTER //
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/app/app.module.ts